import React, { createContext, useContext } from 'react';

export interface PinnedSeriesWidgetContextType {
  isStickyNote: boolean;
}

const PinnedSeriesWidgetContext = createContext<PinnedSeriesWidgetContextType | undefined>(
  undefined,
);

export const usePinnedSeriesWidget = () => {
  const context = useContext(PinnedSeriesWidgetContext);
  if (!context) {
    throw new Error('usePinnedSeriesWidget must be used within a PinnedSeriesWidgetProvider');
  }
  return context;
};

export function PinnedSeriesWidgetProvider({
  children,
  widgetHost,
}: {
  children: (context: PinnedSeriesWidgetContextType) => React.ReactElement;
  widgetHost: any;
}) {
  const isStickyNote = widgetHost.hostId !== 'tabs';

  const contextValue: PinnedSeriesWidgetContextType = {
    isStickyNote,
  };

  return children(contextValue);
}
